{
  "eyebrow": "INSIDE THE DOJO",
  "heading": "See how we train.",
  "intro": "Technique, intensity and the energy of a team that learns together. Get a feel for life on the mats before your first class.",
  "embed_url": "https://www.instagram.com/p/C4gsvziKogj/embed",
  "embed_title": "Tiago de Paula BJJ training video",
  "poster": "/images/mma.jpeg",
  "caption": "No-Gi training and workshops in Zurich",
  "cta_label": "More videos on Instagram",
  "cta_url": "https://www.instagram.com/tiagobjjdepaula"
}
